import styled from "styled-components";
export const Row = styled.div.withConfig({
    displayName: "styled__Row",
    componentId: "sc-48b15272-0"
})`
	padding: 16px 0;

	& + & {
		border-top: 1px solid ${({ theme  })=>theme.colors.grays.light};
	}
`;

//# sourceMappingURL=styled.js.map